import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="fullscreen"
export default class extends Controller {
  static targets = ["container", "scrollArea", "maximizeIcon", "minimizeIcon"];

  toggle() {
    // 1. Toggle the Main Container
    // 'fixed inset-0 z-[60]' anchors it to the edges, placing it above the header (z-50)
    // 'h-[100dvh]' handles the iOS Safari address bar expansion cleanly
    const containerClasses = [
      "fixed",
      "inset-0",
      "z-[60]",
      "h-[100dvh]",
      "rounded-none",
      "sm:rounded-none",
    ];
    containerClasses.forEach((c) => this.containerTarget.classList.toggle(c));

    // 2. Toggle the Scroll Area Aspect Ratios
    // Strips the restricted aspect ratios and forces it to fill the newly expanded container
    this.scrollAreaTarget.classList.toggle("aspect-square");
    this.scrollAreaTarget.classList.toggle("sm:aspect-4/3");
    this.scrollAreaTarget.classList.toggle("h-full");

    // 3. Swap the Icons
    this.maximizeIconTarget.classList.toggle("hidden");
    this.minimizeIconTarget.classList.toggle("hidden");

    // 4. (Optional) Prevent body scrolling underneath
    document.body.classList.toggle("overflow-hidden");
  }
}
